/**
 * モード選択(どっちで あそぶ?)。docs/02_game_design.md §1。
 *
 * 出すボタンは「ことばの せってい」(services/languages)で決まる:
 *   一番左上 = 第一言語(常に出す) → そのあと 学びたい言語の順。
 * 言語を増やしても `LANGUAGES` に1行足すだけで、ここは変えなくてよい。
 *
 * 操作はキーだけでも完結する(docs/15 §2A):数字キーで直接えらび、
 * ←→ で移動、Enter で決定。カードには小さなキーバッジを出す。
 * カードは順番にポン・ポンと出る(§2C)。
 */

import { selectModeOptions, useGameStore } from '../store/gameStore';
import {
  CHOICE_KEYS,
  KeyBadge,
  popInDelay,
  useArrowFocus,
  useChoiceKeys,
} from './components/gameFeel';
import './language.css';

export function ModeSelectScreen() {
  const state = useGameStore();
  const modes = selectModeOptions(state);
  const arrows = useArrowFocus<HTMLButtonElement>();

  const choose = (index: number): void => {
    const option = modes[index];
    if (option?.mode) void state.chooseLanguage(option.mode);
  };

  // 数字キーで直接えらぶ(押せるカードの数までしか反応しない)。
  useChoiceKeys(CHOICE_KEYS, choose);

  return (
    <div className="screen mode-select">
      <h1 className="screen-title">どっちで あそぶ?</h1>
      <div className="mode-cards" onKeyDown={arrows.onKeyDown}>
        {modes.map((option, index) => {
          const key = CHOICE_KEYS[index];
          return (
            <button
              key={option.code}
              type="button"
              ref={arrows.register(index)}
              className={`mode-card gf-pop-in ${option.modeClass}`}
              // 順番ポップイン(docs/15 §2C)。transform / opacity だけを動かす。
              style={popInDelay(index, 60)}
              onClick={() => {
                if (option.mode) void state.chooseLanguage(option.mode);
              }}
            >
              <span className="mode-emoji">{option.modeEmoji}</span>
              <span className="mode-name">{option.modeName}</span>
              <span className="mode-desc">{option.modeDesc}</span>
              {key ? <KeyBadge keyLabel={key} corner className="on-dark" /> : null}
            </button>
          );
        })}
      </div>
      <p className="gf-key-hint">すうじキー か ←→ と Enter でも えらべるよ</p>
      <p className="mode-hint">
        あそべる ことばは「ことばの せってい」で かえられるよ。{' '}
        <button type="button" className="lang-link" onClick={() => void state.goMyPage()}>
          せっていを ひらく
        </button>
      </p>
      <button type="button" className="back-button" onClick={state.goTitle}>
        もどる
      </button>
    </div>
  );
}
